import React from "react";
import PropTypes from "prop-types";

import styles from "./Modal.scss";

const ModalAction = ({ children, ...others }) => (
  <div className={styles.action} {...others}>
    {children}
  </div>
);

ModalAction.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

ModalAction.displayName = "Modal.Action";

export default ModalAction;
